/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./record.defs.js";
export { main as default } from "./record.defs.js";
